import React, { useContext, useMemo } from "react";

import { observer } from "mobx-react";

import ComponentContext from "../../contexts/ComponentContext";
import { useStores } from "../../contexts/StoreContext";
import Hero from "../../shared/components/Hero/Hero";

function SingleJobPage() {
  const component = useContext(ComponentContext);

  const { vacancyStore } = useStores();

  const { selectedVacancy } = vacancyStore;

  const memoizedContext = useMemo(() => {
    return { ...component, text: `# ${selectedVacancy?.title}` };
  }, [component, selectedVacancy]);

  return (
    <ComponentContext.Provider value={memoizedContext}>
      <Hero />
    </ComponentContext.Provider>
  );
}

export default observer(SingleJobPage);
